import FormattedMessage from 'I18n/components/FormattedMessage';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { getDetailsUrl } from 'web-interactives-dashboard-ui/utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
const OpenDetailsAction = ({
  contentId
}) => {
  return /*#__PURE__*/_jsx(UIRouterLink, {
    "data-selenium": "open-details-action",
    onClick: event => {
      event.stopPropagation();
    },
    to: getDetailsUrl(contentId),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "actionMenu.toDetailsPage"
    })
  });
};
export default OpenDetailsAction;